<template>
  <div>
    <div class="d-sm-flex justify-content-between">
      <div>
        <h4>
          Ruta:
          <b-badge variant="info">{{routeName}}</b-badge>
        </h4>
      </div>
      <div>
        <span>
        <b-badge variant="dark">{{routeDate}}</b-badge>
        <transition name="slide-fade" mode="out-in">
          <b-badge :key="statusVariant" pill :variant="statusVariant" class="ml-2">·</b-badge>
        </transition>
      </span>
      </div>
    </div>
    <RouteVehicleInfo :car="carInfo"/>
  </div>
</template>

<script>
import RouteVehicleInfo from './RouteVehicleInfo'

export default {
  name: 'RouteName',
  components: {
    RouteVehicleInfo
  },
  props: {
    routeDate: {
      type: String,
      required: true
    },
    routeStatus: {
      type: String,
      required: true
    },
    routeName: {
      type: String,
      required: true
    },
    car: {
      type: Object,
      required: true
    }
  },
  computed: {
    statusVariant () {
      const variant = {
        inactive: 'light',
        active: 'primary',
        delivered: 'success',
        cancelled: 'danger'
      }
      return variant[this.routeStatus]
    }
  }
}
</script>

<style lang="stylus" scoped>
  .slide-fade-enter-active
    transition: all .3s ease;

  .slide-fade-leave-active
    transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0)

  .slide-fade-enter, .slide-fade-leave-to
    transform: translateX(10px)
    opacity: 0

</style>
